export default "__VITE_ASSET__BMDzp0$n__"